import React, { useState } from "react";
import { Row, Col } from "reactstrap";
import { Link } from "react-router-dom";
import Headings from "../Component/FixedCosts/Headings";
import CardTrial from "../Component/FixedCosts/CardTrial";
import { useTrialAuth } from "../Context/TrialAuthContext";
import DashboardStandard from "../Component/Dashboard/DashboardStandard";
import useWindowSize from "../Component/use-window-size";
import DashboardStandardMobile from "../Component/Dashboard/DashboardStandardMobile";
import { useSelector } from "react-redux";
import NavlinksTrial from "../Component/Navlinks/NavlinksTrial";
import NavlinksMobileTrial from "../Component/Navlinks/NavlinksMobileTrial";
import CompanyFormButtonTrial from "../Component/CompanyFormButton/CompanyFormButtonTrial";
import CompanyFormButtonMobileTrial from "../Component/CompanyFormButton/CompanyFormButtonMobileTrial";

export default function FixedCostsTrial() {
  const [headingFocused, setHeadingFocused] = useState("");
  const { fixedCostData, postLocalData } = useTrialAuth();
  const size = useWindowSize();
  const sizeForMobile = useSelector((state) => state.sizeForMobile.size);
  const activeYear = useSelector((state) => state.year);

  const handleAddRow = () => {
    const newObject = {
      category: "",
      amount: "0",
    };
    postLocalData(newObject);
  };

  return (
    <Row className="mt-5 max-width-container">
      <Col xs={40} className="m-auto g-0 px-5">
        {/* Desktop: Navigation, Year/Company buttons, and Dashboard in one row */}
        {size.width < sizeForMobile ? (
          <>
            {/* Mobile: Navigation - Fasta Kostnader enabled */}
            <Row>
              <NavlinksMobileTrial />
            </Row>

            {/* Mobile: Year/Company buttons - disabled for trial */}
            <div style={{ pointerEvents: "none", opacity: 0.5 }}>
              {/* Year buttons */}
              <Row className="d-flex align items center justify-content-center">
                <Col
                  xs={10}
                  className="m-1 responsive-fontsize fw-bold year-button-focused"
                >
                  <p className="year-text">År 1</p>
                </Col>
                <Col
                  xs={10}
                  className="m-1 responsive-fontsize fw-bold year-button"
                >
                  <p className="year-text">År 2</p>
                </Col>
                <Col
                  xs={10}
                  className="m-1 responsive-fontsize fw-bold year-button"
                >
                  <p className="year-text">År 3</p>
                </Col>
              </Row>
            </div>
            {/* Company form buttons - active */}
            <CompanyFormButtonMobileTrial />

            {/* Mobile: Dashboard */}
            <DashboardStandardMobile />
          </>
        ) : (
          <Row className="mb-5">
            {/* Desktop: Navigation (left) - Fasta Kostnader enabled */}
            <NavlinksTrial />

            {/* Desktop: Year/Company buttons (middle) - disabled for trial */}
            <Col xs={10} className="offset-10">
              <div style={{ pointerEvents: "none", opacity: 0.5 }}>
                {/* Year buttons */}
                <Row className="d-flex align items center justify-content-center">
                  <Col
                    xs={10}
                    className="m-1 responsive-fontsize fw-bold year-button-focused"
                  >
                    <p className="year-text">År 1</p>
                  </Col>
                  <Col
                    xs={10}
                    className="m-1 responsive-fontsize fw-bold year-button"
                  >
                    <p className="year-text">År 2</p>
                  </Col>
                  <Col
                    xs={10}
                    className="m-1 responsive-fontsize fw-bold year-button"
                  >
                    <p className="year-text">År 3</p>
                  </Col>
                </Row>
              </div>
              {/* Company form buttons - active */}
              <CompanyFormButtonTrial />
            </Col>

            {/* Desktop: Dashboard (right) */}
            <DashboardStandard />
          </Row>
        )}

        <Col xs={size.width < sizeForMobile ? 0 : 16} className="m-auto g-0">
          {size.width < sizeForMobile ? (
            ""
          ) : (
            <Headings headingFocused={headingFocused} />
          )}
          <div
            className={
              size.width < sizeForMobile ? "scrollbox-mobile" : "scrollbox"
            }
          >
            <div className="content-wrapper">
              {fixedCostData &&
                fixedCostData.fixedCostData &&
                fixedCostData.fixedCostData
                  .filter((item) => item.year === activeYear.year)
                  .map((card) => (
                    <div key={card.id}>
                      <CardTrial
                        data={card}
                        setHeadingFocused={setHeadingFocused}
                      />
                    </div>
                  ))}
              <div className="button-add-row" onClick={handleAddRow}>
                <p className="plus">+</p>
              </div>
            </div>
          </div>
        </Col>
        <div className="mt-4 text-center">
          <p className="text-muted">
            Detta är en provversion - dina ändringar sparas inte
          </p>
          <p>
            För att spara data behöver du ett betalt konto:{" "}
            <Link to="/signUp" className="fw-bold">
              Skapa ett konto
            </Link>
          </p>
          <p>
            Har du redan ett konto?{" "}
            <Link to="/login" className="fw-bold">
              Logga in
            </Link>
          </p>
        </div>
      </Col>
    </Row>
  );
}
